import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  attemptCount: PropTypes.number,
  correct: PropTypes.number.isRequired,
  incorrect: PropTypes.number.isRequired,
  locked: PropTypes.bool,
  onRetakeClick: PropTypes.func,
  previousPercentCorrect: PropTypes.number,
  reviewLink: PropTypes.string.isRequired,
  skipped: PropTypes.number.isRequired
};

const defaultProps = {
  attemptCount: 1,
  locked: false,
  onRetakeClick: () => {},
  previousPercentCorrect: null
};

function Counter({ label, count }) {
  const className = label.toLowerCase();
  return (
    <div className="ResultsPanel--score">
      <div className={`ResultsPanel--score-number ${className}`}>{count}</div>
      <span>{label}</span>
    </div>
  );
}

export default function ResultsPanel({
  attemptCount,
  correct = 0,
  incorrect = 0,
  locked,
  onRetakeClick,
  previousPercentCorrect,
  reviewLink,
  skipped = 0
}) {
  const total = correct + incorrect + skipped;
  const percentCorrect = (correct / total) * 100;
  const roundedPercentage = Math.round(percentCorrect) || 0;
  const summaryText =
    attemptCount > 1
      ? `You got ${previousPercentCorrect}% correct last time.`
      : `You got ${correct} of ${total} correct.`;

  const amplitudeEvent = locked
    ? "quizLockedRetakeButton"
    : "quizUnlockedRetakeButton";
  const amplitudeFunnel = locked ? "paid" : "none";

  return (
    <div className="ResultsPanel--container" data-testid="QuizResultsPanel">
      <div className="ResultsPanel--left-content">
        <div className="ResultsPanel--left-percentage">
          <span className="ResultsPanel--left-percentageText">
            {roundedPercentage}%
          </span>
        </div>
        <div className="ResultsPanel--left-overview body-1">
          <Counter count={correct} label="Correct" />
          <Counter count={incorrect} label="Incorrect" />
          {skipped > 0 && <Counter count={skipped} label="Skipped" />}
        </div>
      </div>
      <div className="ResultsPanel--right-content">
        <div>
          {summaryText} Keep going!{" "}
          <a href={reviewLink}>Review the summary &amp; analysis</a>, retake
          this quiz, or review your answers below.
        </div>
        <div>
          <button
            className="ResultsPanel--right-btn btn btn-a-plus button-1 btn-lg"
            data-amplitude={amplitudeEvent}
            data-amplitude-funnel={amplitudeFunnel}
            onClick={onRetakeClick}
            id="retake-quiz-button"
            type="button"
          >
            {locked && <i className="lc-icon lc-icon-lock-filled lc-icon-sm" />}
            <span>Retake Quiz</span>
          </button>
        </div>
      </div>
    </div>
  );
}

ResultsPanel.defaultProps = defaultProps;
ResultsPanel.propTypes = propTypes;
